import { createSlice } from '@reduxjs/toolkit'

export const authSlice = createSlice({
    name: 'auth',

    initialState: {
        token: localStorage.getItem('token') || null,
        isAuth: !!localStorage.getItem('token'),
        userId: Number(localStorage.getItem('userId')) || 0,
        userType: localStorage.getItem('userType') || null,
        isTrustedUser: !!localStorage.getItem('isTrustedUser'),
    },

    reducers: {
        loginRdx: (state, action) => {
            state.token = action.payload.token;
            state.isAuth = true;
            state.userId = action.payload.userId;
            state.userType = action.payload.userType || null;
            state.isTrustedUser = action.payload.isTrustedUser;

            localStorage.setItem('userId', action.payload.userId);
            localStorage.setItem('token', action.payload.token);
            localStorage.setItem('userType', action.payload.userType);
            localStorage.setItem('isTrustedUser', action.payload.isTrustedUser);
        },

        logoutRdx: (state) => {
            state.token = "";
            state.isAuth = false;
            state.userId = 0;
            state.userType = null;
            state.isTrustedUser = false;
            localStorage.removeItem('token');
            localStorage.removeItem('userId');
            localStorage.removeItem('userType');
            localStorage.removeItem('isTrustedUser');
        },
    },
})

export const { loginRdx, logoutRdx } = authSlice.actions
export default authSlice.reducer